<template>
  <section>
    <PublicNavigation />
    <div class="container">
      <div class="row">
        <div class="col-md-8 mx-auto">
          <div class="privacy">
            <h1 style="color:#000">General Conditions for Employers</h1>
            <p class="revision">
              Last revision: 2023-10-13
            </p>
            <p>
              This is an agreement between Comstream AB, Swedish registration number 556945-8911,
              hereinafter referred to as ”Comstream” and the Customer regarding the use of the
              online recruiting service platform, hereinafter “Jobshark”.
            </p>
            <P
              >To be able to use Jobshark, you must carefully read the text and accept the
              conditions below.</P
            >
            <ul class="list-unstyled">
              <li>
                <h2>1. General Conditions</h2>
                <p>
                  By using the Service, the Customer gains access to job-seeking candidates,
                  hereinafter "Candidates", with CVs and associated contact details for a certain
                  job position, hereinafter "Position", registered via Jobshark.
                </p>
                <p>
                  It is the Customer's responsibility to provide an adequate description of the
                  Position and other relevant information for the Position. Jobshark may only be
                  used for Positions that refer to employment or contract directly with the
                  Customer. Comstream has the right to refuse a Position at its sole discretion
                </p>
                <p>
                  The Customer hereby consents to Comstream presenting the Position and basic
                  information about the Customer to possible Candidates, as well as the Position and
                  basic information about the Customer being advertised via Jobshark. Jobshark also
                  has the right, at its sole discretion, to advertise the Position and basic
                  information about the Customer through other channels such as social media and
                  other job sites.
                </p>
                <p>
                  If Comstream produces the job advertisement for a Position, the Customer may not
                  use this in other contexts than for advertising via Jobshark.
                </p>
                <p>
                  The Customer may not redistribute received Candidates to third parties without
                  Comstream's approval.
                </p>
              </li>
              <li>
                <h2>2. Policy for Advertising</h2>
                <p>
                  The following advertising guidelines apply. A job advertisement may not be used
                  to:
                </p>
                <ul class="list-unstyled">
                  <li>(a) advertise more than one job or more than one location</li>
                  <li>
                    (b) publish or offer jobs that do not comply with current legislation in any
                    respect including labor laws, equality, discrimination, illegal stay, etc.
                  </li>
                  <li>(c) market or sell products or services</li>
                  <li>
                    (d) advertise or offer a business opportunity that does not involve employment
                    or contract under presented conditions
                  </li>
                  <li>
                    (e) advocate any particular political party, political program, political
                    position or any political agenda
                  </li>
                  <li>(f) advocate any particular religion</li>
                  <li>
                    (g) require Candidates to provide information about age, race or ethnic origin,
                    political beliefs, religious beliefs, sexual orientation or other information of
                    a strictly private nature
                  </li>
                </ul>
              </li>
              <li>
                <h2>3. Fees and Payment Conditions</h2>
                <p>
                  Certain services offered by Comstream are associated with a cost. The Customer may
                  order and accept the conditions for such services via Jobshark.
                </p>
                <p>
                  Payment terms are 30 days from the invoicing date. In case of delay of payment,
                  the Customer shall be obliged to pay penalty interest amounting to 12% per year.
                  All mentioned fees are exclusive of VAT.
                </p>
              </li>
              <li>
                <h2>4. Agreement Term</h2>
                <p>
                  The service is provided during the stated advertising period, after which the
                  Customer has access to the information in Jobshark for at least one (1) more year.
                  The Customer has the right to cancel the advertising and other recruitment
                  activities prematurely.
                </p>
              </li>
              <li>
                <h2>5. Intellectual Property</h2>
                <p>
                  The Customer may not use or forward job ads, advertising materials or descriptions
                  of the competence profile that Comstream produces.
                </p>
              </li>
              <li>
                <h2>6. Cookies</h2>
                <p>
                  Jobshark is using cookies to improve the user experience. To be able to
                  continuously develop our services and products and to be able to customize our
                  information to you, we may also gather information about what web browser you are
                  using, your IP address and similar information.
                </p>
              </li>
              <li>
                <h2>7. Processing of Personal Data</h2>
                <p>
                  Comstream and the Customer are jointly considered to be Processors of personal
                  data according to GDPR. Both parties commit on adhering to GDPR and other relevant
                  legislation as for the handling of personal data.
                </p>
                <p>
                  A Candidate’s personal data will be processed after acceptance of Comstream’s
                  Integrity Policy.
                </p>
              </li>
              <li>
                <h2>8. Limitation of Liability</h2>
                <p>
                  Comstream is not responsible for any indirect damages of any kind and the
                  liability is in all cases limited to the amount that the Customer has paid for the
                  service.
                </p>
              </li>
              <li>
                <h2>9 Applicable Laws</h2>
                <p>
                  This Contract shall be governed by the laws of Sweden and any dispute shall be
                  settled by a general Swedish court of law.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import PublicNavigation from '../../components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title: 'Privacy Policy | Jobshark',
  components: {
    PublicNavigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.container {
  max-width: 1320px;
}
.privacy {
  padding: 100px 0;
  h1 {
    font-weight: 700;
    font-size: 24px;
  }
  .revision {
    font-style: italic;
    font-weight: 600;
    font-size: 14px;
  }
  .list-unstyled {
    li {
      margin-bottom: 12px;
      h2 {
        font-size: 16px;
        font-weight: 900;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
